import { createAction } from '@reduxjs/toolkit';

export const TRANSACTION_FLUSH = createAction('transaction/flush');

export const TRANSACTION_FIRE = createAction('transaction/fire');
